module.exports = "data:image/webp;base64,UklGRrgAAABXRUJQVlA4IKwAAADwBACdASoZABkAPpFAmkklo6KhKAqosBIJZwDH6bYxlsaQbTMIyMJKsGtC9vtoTgAA/uxq5Oy/0A/bEDVqJnwj7NARd2MpdzQvnjcfyr1ejKrSINM6/PqcHU40lxkglrjXBdmORargEcNmfKNxlTdcfuNMfZDm2+dv+eD3yT8QpttptMkNjrsVvAmqZ7/X60eB0Y6DsOUw0Kmlvlb0RbD5Uuaj2xYWuaw3oAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/blue_obsession_wash.webp
// module id = t9ab
// module chunks = 14